var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeoreact = function SvgIdeoreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M64.27 13a7.37 7.37 0 0 0-7.23 7.5c0 4.14 3.24 7.5 7.23 7.5a7.37 7.37 0 0 0 7.23-7.5c0-4.14-3.24-7.5-7.23-7.5ZM9 13.6v2.43h5.4V25H9v2.43h13.14V25h-5.38v-8.96h5.38V13.6H9Zm16.62 0v13.8h6.3a6.73 6.73 0 0 0 6.89-6.92 6.7 6.7 0 0 0-6.77-6.88h-6.42Zm16.05 0v13.82h13.27V25H44.05v-3.26h8.5V19.3h-8.5v-3.27h10.9V13.6H41.66Zm22.6 2.02c2.6 0 4.74 2.2 4.74 4.9 0 2.71-2.14 4.91-4.74 4.91s-4.74-2.2-4.74-4.9c0-2.72 2.12-4.91 4.74-4.91Zm-36.29.37h4c2.57.07 4.27 1.96 4.27 4.53-.02 2.6-1.72 4.47-4.32 4.52h-3.95v-9.05Z"
  })));
};
export default SvgIdeoreact;